import { appUrl } from "../../constants/url-constants";
import Filters from "../filters-v2";

const RESUME_FILTER_SESSION_DATA = "resume_filter_session_data";

const getCookieData = (cookieName) => {
    if (typeof window === "undefined") return {};

    const cookiePrefix = `${cookieName}=`;
    const cookie = document.cookie
        .split(";")
        .map(item => item.trim())
        .find(item => item.startsWith(cookiePrefix));

    if (!cookie) return {};

    const cookieValue = cookie.slice(cookiePrefix.length);

    try {
        return JSON.parse(cookieValue);
    } catch (error) {
        try {
            return JSON.parse(decodeURIComponent(cookieValue));
        } catch (decodeError) {
            return {};
        }
    }
};

export default (shouldApplySelectedFilter = false) => {
    const filters = new Filters({ cityCode: "", cityName: "" });
    const { absoluteURL } = filters.getListingPayload({ selectedFilters: [], filters: {} });

    if (!shouldApplySelectedFilter) return absoluteURL;

    const { latestFilterUrl } = getCookieData(RESUME_FILTER_SESSION_DATA);
    return latestFilterUrl ? `${appUrl()}${latestFilterUrl}` : absoluteURL;
};
